import styled from 'styled-components';

export const ModalContentStyled = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;

  .modal-header {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    box-sizing: border-box;

    .modal-title {
      flex-grow: 1;
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      letter-spacing: -0.02em;
      color: ${({ theme }) => theme.colors.gray[80]};
    }
  }

  .modal-content {
    padding: 16px;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .modal-footer {
    padding: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray[10]};
  }
`;
